import { render, staticRenderFns } from "./GameCompare.vue?vue&type=template&id=c3db1dfc&scoped=true"
import script from "./GameCompare.vue?vue&type=script&lang=js"
export * from "./GameCompare.vue?vue&type=script&lang=js"
import style0 from "./GameCompare.vue?vue&type=style&index=0&id=c3db1dfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db1dfc",
  null
  
)

export default component.exports